export enum RulebookModeEnum {
    Traditional = 1,
    CBTC = 2,
    Both = 3
}

export const RulebookNameToEnum = ((mode: string | null) => {
    switch (mode) {
        case 'traditional':
            return RulebookModeEnum.Traditional;
            break;
        case 'cbtc':
            return RulebookModeEnum.CBTC;
            break;
        default: RulebookModeEnum.Traditional
    }
});

export const RulebookEnumToString = ((mode: RulebookModeEnum) => {
    switch (mode) {
        case RulebookModeEnum.Traditional:
            return 'traditional';
            break;
        case RulebookModeEnum.CBTC:
            return 'cbtc';
            break;
        default: 'traditional'
    }
});